import { FormBase } from 'core/components';

export default class WarehouseCodesForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: ['warehouseCodes', 'warehouseCodes[].warehouseName', 'warehouseCodes[].name'],
			labels: {
				'warehouseCodes[].warehouseName': 'WAREHOUSECODES.WAREHOUSE',
				'warehouseCodes[].name': 'WAREHOUSECODES.CODE',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/WarehouseCodesForm.js